import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ReportContext from '@totem/components/cyberReview/CyberReportContext';
import { OrganizationReport } from '@totem/components/cyberReview/dataTypes';
import { ReportInput } from '@totem/components/cyberReview/parameterTypes';
import { buildReportFilters } from '@totem/components/cyberReview/utilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { Params } from '@totem/types/common';
import { CYBER_REVIEW_REPORT } from '@totem/utilities/endpoints';
import { omitNilOrEmpty } from '@totem/utilities/objectUtilities';
type Props = {
  refresh?: boolean;
  onRecordTotalChanged?: (total: number) => void;
  onDataRefreshRequested?: () => void;
  children?: ReactNode;
  deviceEndPoint?: string;
};
const CyberReportContainer = ({
  children,
  refresh,
  onRecordTotalChanged,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [input, updateInput] = useState<ReportInput>({
    pageSize: 10,
    page: 1,
    sortField: 'name',
    sortDirection: '1',
    name: '',
    username: '',
  });
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [reportData, setReportData] = useState<OrganizationReport>(null);
  const setInput = (updated: Partial<ReportInput>) => {
    updateInput(omitNilOrEmpty({ ...input, ...updated }));

    setRefreshData(true);
  };
  const buildParameters = () => {
    const params: Params = {
      paging: {
        page: input.page,
        pageSize: input.pageSize,
      },
      sort: {
        field: input.sortField,
        direction: +input.sortDirection,
      },
      filters: buildReportFilters(input),
    };
    return params;
  };
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);
      const params: Params = buildParameters();
      fetch(`${CYBER_REVIEW_REPORT}`, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(params),
      })
        .then((res) => res.json())
        .then((result: OrganizationReport) => {
          setReportData(result);

          setTotalRecords(result.paging.totalRecords);
          if (
            typeof onRecordTotalChanged !== 'undefined' &&
            onRecordTotalChanged !== null
          ) {
            onRecordTotalChanged(result.paging.totalRecords);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, refresh, getApiToken]);
  const handleAction = (newAction: string) => {
    switch (newAction) {
      case 'refresh':
        setRefreshData(true);
        break;
      default:
        break;
    }
  };
  return (
    <ReportContext.Provider
      value={{
        input,
        setInput,
        onAction: handleAction,
        loading: isLoading,
        reportData,
        totalRecords,
      }}
    >
      <div>{children}</div>
    </ReportContext.Provider>
  );
};
export default CyberReportContainer;
